import { useUserStore } from '@/stores/user';
import { useAuthStore } from '@/stores/auth';
import { Md5 } from 'ts-md5';
import { changePassword, login, resetPassword } from '@/api/user';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';

export function useSaveLogin(data: any) {
    const userStore = useUserStore();
    const authStore = useAuthStore();
    authStore.setToken(data.token, data.refreshKey);
    userStore.setUserInfo(data);
}

// 更新微信相关
export function useSaveBindWx(data?: any){
    const userStore = useUserStore();
    userStore.updateBindWx(data);
}
export function useLogin(params: any) {
    
    const data = {
        account: params.account,
        password: Md5.hashStr(params.password),
    };

    return new Promise((resolve, reject) => {
        login(data)
            .then((res) => {
                if (res.code === 0) {
                    // 保存token
                    useSaveLogin(res.data)
                    resolve(res);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
}


export function useLogOut() {
    const userStore = useUserStore();
    const authStore = useAuthStore();
    authStore.clearToken();
    userStore.clearUserInfo();
}

export function useChangePwd(params: any) {
    const p = {
        oldPsw: Md5.hashStr(params.oldPsw),
        newPsw: Md5.hashStr(params.newPsw),
        confirmPsw: Md5.hashStr(params.confirmPsw),
    };
    return new Promise((resoleve, reject) => {
        changePassword(p)
            .then((res) => {
                if (res.code == 0) {
                    useLogOut();
                    resoleve(res);
                } else {
                    reject();
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
}

export function useForget(params: any){
    const p = {
        password: Md5.hashStr(params.password),
        confirm_password: Md5.hashStr(params.confirm_password),
        email: params.email,
        key: params.key
    }
    
    return new Promise((resoleve, reject) => {
        resetPassword(p)
            .then((res) => {
                if (res.code == 0) {
                    useLogOut();
                    resoleve(res);
                } else {
                    reject();
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
}
